import React, { Component } from 'react'
import classnames from 'classnames'
import Select from 'antd/lib/select'
import { difference } from 'lodash'
import { translate } from 'react-i18next'
import './index.sass'

const { Option } = Select

class CustomSelect extends Component {
  state = {
    isDropDownVisible: false,
    optionsForRender: [],
  }

  componentDidMount() {
    window.addEventListener('wheel', this.onScroll)
  }
  componentWillUnmount() {
    window.removeEventListener('wheel', this.onScroll)
  }

  onScroll = e => {
    const { isDropDownVisible } = this.state
    if (!e.target.className.includes('ant-select-dropdown') && isDropDownVisible) {
      this.test.rcSelect.setOpenState(false)
    }
  }

  onSearch = (inputValue, option) => {
    if (option.props.label.toLowerCase().includes(inputValue.toLowerCase())) {
      return true
    }
    return false
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { option, opt, t } = this.props
    if (
      (prevState.isDropDownVisible && !this.state.isDropDownVisible) ||
      prevProps.lng !== this.props.lng
    ) {
      const notSelectedOptions = this.formatOptions(
        difference(option.values, opt[option.name.toLowerCase()]),
        option,
        t
      ).sort((a, b) => a.value.localeCompare(b.value))
      const selectedOptions = this.formatOptions(opt[option.name.toLowerCase()], option, t)
        .map(elem => ({ ...elem, selected: true }))
        .sort((a, b) => a.value.localeCompare(b.value))
      this.setState({
        optionsForRender: [...selectedOptions, ...notSelectedOptions],
      })
    }
  }

  onDropDownVisibleChange = value => {
    this.setState({
      isDropDownVisible: value,
    })
  }

  formatOptions = (arr, option, t) =>
    arr.map(el => ({
      initialValue: el,
      value: option.name === 'Language' ? t(`Language.${el}`) : t(`filter.${el}`),
    }))

  render = () => {
    const { handleChange, option, clearAllFilters, opt, t } = this.props
    const { isDropDownVisible, optionsForRender } = this.state
    const isFiltersSelected = opt[option.name.toLowerCase()].length > 0
    const classes = classnames({
      'filter-select': true,
      'filter-select-open': isDropDownVisible,
      'show-search': isDropDownVisible && opt[option.name.toLowerCase()].length === 0,
    })
    const transaltedOptions =
      optionsForRender.length > 0
        ? optionsForRender
        : this.formatOptions(option.values, option, t).sort((a, b) =>
            a.value.localeCompare(b.value)
          )
    const lastSelectedIndex = optionsForRender.filter(el => el.selected).length
    return (
      <div className={classes}>
        <p className="subtitle-2">{t(`general.${option.name}`)}</p>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder={
            !isDropDownVisible
              ? `${t('filter.select')} ${t(`general.${option.name}`)}`
              : t('filter.type')
          }
          defaultValue={[]}
          onChange={e => handleChange(e, option.name)}
          showArrow={true}
          value={opt[option.name.toLowerCase()]}
          dropdownClassName="custom-select"
          onDropdownVisibleChange={this.onDropDownVisibleChange}
          maxTagCount={1}
          maxTagTextLength={10}
          filterOption={this.onSearch}
          ref={ref => (this.test = ref)}
        >
          {transaltedOptions.map((elem, ind) => (
            <Option
              value={elem.initialValue}
              label={elem.value}
              key={ind}
              className={lastSelectedIndex - 1 === ind && 'last-selected'}
            >
              {elem.value}
            </Option>
          ))}
        </Select>
        {isFiltersSelected && !isDropDownVisible && (
          <div
            onClick={() => {
              this.setState({
                optionsForRender: [],
              })
              clearAllFilters(option.name.toLowerCase())
            }}
            className="clear-all body-light"
          >
            {`${t('filter.clear')} (${opt[option.name.toLowerCase()].length})`}
          </div>
        )}
      </div>
    )
  }
}

export default translate('translations')(CustomSelect)
